"use client"
import Link from "next/link";
import { usePathname } from "next/navigation";
import clsx from "clsx";
import { useEffect, useState } from "react";
import { useUserInfoStore } from "@/models/userInfo";
import { useRouter } from "next/navigation";
import { addToast } from "@heroui/react";
import { getUserInfo, logoutService } from "@/services/user";
import tabs from "@/constant/tabs";
import { IOS_APP_DOWNLOAD_URL, ANDROID_APP_DOWNLOAD_URL } from "@/lib/constant";


export default function Slider() {
  const [currentTab, setCurrentTab] = useState<string>("Home")
  const router = useRouter()
  const pathname = usePathname();
  useEffect(() => {
    const currentTab = tabs.find(tab => tab.href === pathname)?.name || "For You"
    setCurrentTab(currentTab)
  }, [pathname])
  const { isLogin } = useUserInfoStore()
  useEffect(() => {
    if (!isLogin && currentTab === "Following") {
      router.push("/")
    }

  }, [isLogin, currentTab])
  // Get current hover menu
  return (
    <nav className="flex flex-col w-64 bg-white dark:bg-gray-900 px-4 h-[calc(100vh-65px)] relative overflow-y-auto">
      <div className="space-y-2 pt-10 overflow-auto pb-[300px]">
        <div className="h-[600px]">
          {(isLogin ? tabs : tabs.slice(0, 1).concat(tabs.slice(2))).map((tab) => (
            <Link
              key={tab.name}
              href={tab.href}
              className={clsx(
                "flex items-center gap-3 hover:text-black dark:hover:text-white hover:font-semibold transition-colors py-2 px-4",
                currentTab?.toLowerCase() === tab?.name?.toLowerCase?.() ? "text-black dark:text-white font-bold" : "text-gray-600 dark:text-gray-400",
                "hover:text-black dark:hover:text-white hover:font-semibold transition-colors py-1 hover:bg-gray-100 dark:hover:bg-gray-800 rounded-md"
              )}
              onClick={() => {
                track("click_menu", {
                  menu: tab.name,
                  href: tab.href,
                  type: "dynamic_page",
                  page: tab.name
                });
              }}
            >
              {/* {tab.icon && (
                <span className="flex-shrink-0">
                  {tab.icon()}
                </span>
              )} */}
              <span>{tab.name}</span>
            </Link>
          ))}
          <div className={clsx("mt-2 pt-2", { "border-t border-gray-200 dark:border-gray-700": isLogin })}>
            <LoginBar />
          </div>
        </div>
      </div>
      <div className="absolute bottom-0 left-4 right-0">
        <AppDownload />
        <InfoBar />
      </div>
    </nav>
  );
}
const InfoBar = () => {
  return (
    <div className="w-64 bg-white dark:bg-gray-900 px-2 py-6 text-sm">
      {/* About ZESTS Section */}
      <div className="mb-6">
        <h3 className="text-gray-500 dark:text-gray-400 font-bold mb-2 text-xs uppercase tracking-wide">
          ABOUT ZESTS
        </h3>
        <hr className="border-gray-200 dark:border-gray-700 mb-4" />
        <div className="space-y-1">
          <Link href="/home" className={linkClassName} onClick={() => {
            track("click_menu", {
              menu: "About Us",
              href: "/home",
              type: "static_page"
            });
          }}>About Us</Link>
          <Link href="/terms" className={linkClassName} onClick={() => {
            track("click_menu", {
              menu: "Terms of Use",
              href: "/terms",
              type: "static_page"
            });
          }}>Terms of Use</Link>
          <Link href="/privacy" className={linkClassName} onClick={() => {
            track("click_menu", {
              menu: "Privacy Policy",
              href: "/privacy",
              type: "static_page"
            });
          }}>Privacy Policy</Link>
          <Link href="/dsmi" className={linkClassName} onClick={() => {
            track("click_menu", {
              menu: "Don't Sell My Info",
              href: "/dsmi",
              type: "static_page"
            });
          }}>Don't Sell My Info</Link>
        </div>
      </div>
      {/* Copyright */}
      <div className="text-xs text-gray-400 dark:text-gray-500">
        Copyright © 2025  Life Agents, LLC
      </div>
    </div>
  );
}

const linkClassName = "pl-2 block text-gray-600 dark:text-gray-400 hover:text-black dark:hover:text-white py-1 hover:text-black dark:hover:text-white hover:font-semibold transition-colors py-1 hover:bg-gray-100 dark:hover:bg-gray-800 rounded-md"
import EmailLogin from '@/components/emailLogin'
import useLogin from "@/hooks/useLogin";
import useStatusStore from "@/models/status";
import { clearUserId, track } from "@/lib/log";

const LoginBar = () => {
  const { userInfo, isLogin, logOut, setUserInfo } = useUserInfoStore();
  const { loginModalVisible, setLoginModalVisible } = useLogin();
  const { clearLikedDocList, clearFollowedUserList } = useStatusStore();
  function handleLogout() {
    console.log("🚀 ~ handleLogout ~ handleLogout:")

    logoutService();
    logOut();
    clearUserId();
    clearLikedDocList();
    clearFollowedUserList();
    window.location.reload();
  }
  function checkLogin() {
    getUserInfo().then((res: any) => {
      console.log("🚀 ~ getUserInfo ~ res:", res)
      if (res.code === 0) {
        setUserInfo({
          ...userInfo,
          ...res.result,
        })
      } else {
        // setIsLogin(false)
        handleLogout()
      }
    })
  }
  useEffect(() => {
    if (isLogin) {
      checkLogin()
    } else {
      if (document.cookie.includes("Authorization") || document.cookie.includes("JSESSIONID")) {
        checkLogin()
      }
    }
  }, [isLogin])
  const router = useRouter()
  return (
    <>

      {isLogin ? (
        <div className="relative group">
          <div className="flex items-center space-x-2 md:space-x-1 cursor-pointer hover:opacity-80 transition-opacity hover:bg-gray-100 dark:hover:bg-gray-800 rounded-full p-2 w-full" onClick={() => {
            router.push(`/users/${userInfo.profile_id}`)
          }}>
            <img
              src={userInfo.profile_url}
              alt={userInfo.nickname}
              width={32}
              height={32}
              className="rounded-full !max-h-[32px] !max-w-[32px] min-w-[32px] min-h-[32px] mr-1"
            />
            <div className="text-sm hidden sm:block font-semibold text-wrap w-full break-words dark:text-white">
              {userInfo.nickname}
            </div>
          </div>
          {/* 下拉菜单 */}
          <div className="absolute right-0 top-full mt-2 w-48 bg-white dark:bg-gray-800 rounded-lg shadow-lg border border-gray-200 dark:border-gray-700 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 z-50 py-5">
            <button
              onClick={() => {
                handleLogout();
              }}
              className="block w-full text-left px-4 py-2 text-sm text-red-600 dark:text-red-400 hover:bg-red-50 dark:hover:bg-red-900/20 transition-colors"
            >
              Logout
            </button>
          </div>
        </div>
      ) : (
        <div
          className="text-white bg-black dark:bg-white dark:text-black rounded-full w-full border-none cursor-pointer py-2 px-4 text-center"
          onClick={() => {
            setLoginModalVisible(true);
          }}
        >
          Sign in
        </div>
      )}
      {loginModalVisible && <EmailLogin
        isOpen={loginModalVisible}
        onOpenChange={(open) => {
          setLoginModalVisible(open);
        }} />
      }
    </>
  )
}

const AppDownload = () => {

  return (
    <div className="relative group w-60 sm:w-64 mx-auto">
      <div
        role="button"
        tabIndex={0}
        aria-label="Download Zests app"
        className="w-[200px] h-[100px] bg-transparent text-black dark:text-white rounded-2xl cursor-pointer flex items-center hover:bg-gray-100 dark:hover:bg-gray-800 pl-3"
      >
        <div className="flex gap-2 items-center w-full mx-auto">
          <div className="flex items-center gap-1">
            <span className="leading-none">Get App</span>
            <svg className="w-3 h-3 opacity-60" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" />
            </svg>
          </div>
          <div className="bg-[rgb(251,230,114)] dark:bg-[rgb(251,230,114)] rounded-lg w-[50px] h-[50px] flex items-center justify-center">
            <img src="/images/logo.png" alt="Zests logo" className="h-[50px] w-auto" />
          </div>
        </div>
      </div>

      {/* QR 弹层 */}
      <div className="absolute left-1/2 -translate-x-1/2 bottom-full mb-3 opacity-0 invisible group-hover:opacity-100 group-hover:visible group-focus-within:opacity-100 group-focus-within:visible transition-all duration-200 z-50">
        <div className="relative bg-white dark:bg-gray-800 p-3 rounded-xl shadow-xl border dark:border-gray-700 text-center">
          <img src="/images/qrcode/download_prod.png" alt="Zests download QR code" className="min-w-[140px] min-h-[140px] bg-white rounded-md" />
          <div className="text-xs text-gray-500 dark:text-gray-400 mt-2">Scan to download</div>
          {/* 箭头 */}
          <div className="absolute left-1/2 -translate-x-1/2 -bottom-1 w-3 h-3 bg-white dark:bg-gray-800 rotate-45 border-b border-r dark:border-gray-700"></div>
        </div>
      </div>
    </div>
  )
}
